import React from 'react'
import scrollSnapPolyfill from 'css-scroll-snap-polyfill'
import './App.css'
import ContactForm from './ContactForm/ContactForm'
// import Nav from "./Nav/Nav";
import Section from './UI/Section'
import Welcome from './Welcome/Welcome'
import About from './About'
// import Library from "./Library/Library";
// import Technical from "./Technical/Technical";
// import Creative from "./Creative/Creative";
import Passion from './Passion/Passion'
import Footer from './Footer/Footer'
import styled from '@emotion/styled'

const StyledContainer = styled('div')`
    scroll-snap-type: y mandatory;
`

const App = () => {
    return (
        <StyledContainer>
            <Section>
                <Welcome />
            </Section>
            <Section>
                <About />
            </Section>
            <Section>
                <Passion />
            </Section>
            <Section>
                <ContactForm />
            </Section>
            <Footer />
        </StyledContainer>
    )
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js